(() => {
  function initialise(root = document) {
    root.querySelectorAll('[data-hny-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const thumbs = [...gallery.querySelectorAll('[data-gallery-index]')];
      if (!thumbs.length) return;
      const main = gallery.querySelector('.main-photo img');
      const detail = gallery.querySelector('.pdp-detail-photo img');
      const dialog = gallery.querySelector('dialog');
      const large = dialog.querySelector('img');
      let index = Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));
      let returnFocus;
      function show(value) {
        index = (value + thumbs.length) % thumbs.length;
        main.srcset = ''; main.src = thumbs[index].dataset.imageUrl;
        main.alt = `${gallery.dataset.name} · photograph ${index + 1}`;
        large.srcset = ''; large.src = main.src; large.alt = main.alt;
        if (detail) {detail.srcset = ''; detail.src = thumbs[(index + 1) % thumbs.length].dataset.imageUrl;}
        thumbs.forEach((t, i) => t.setAttribute('aria-pressed', String(i === index)));
        gallery.querySelector('[data-gallery-count]').textContent = `Photo ${index + 1} of ${thumbs.length}`;
        gallery.querySelector('[data-lightbox-count]').textContent = `${index + 1} / ${thumbs.length}`;
      }
      thumbs.forEach((t,i) => t.addEventListener('click', () => show(i)));
      gallery.querySelectorAll('[data-gallery-next]').forEach(b => b.addEventListener('click', () => show(index + 1)));
      gallery.querySelector('[data-gallery-previous]').addEventListener('click', () => show(index - 1));
      gallery.querySelector('.pdp-open-photo').addEventListener('click', event => {returnFocus = event.currentTarget; dialog.showModal();});
      gallery.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => returnFocus?.focus());
      dialog.addEventListener('click', e => {if (e.target === dialog) dialog.close();});
      dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {e.preventDefault(); show(index + (e.key === 'ArrowRight' ? 1 : -1));}
      });
      let touchX;
      [main,large].forEach(surface => {
        surface.addEventListener('touchstart', e => {touchX = e.changedTouches[0].clientX;}, {passive:true});
        surface.addEventListener('touchend', e => {const dx = e.changedTouches[0].clientX - touchX; if(Math.abs(dx)>55) show(index + (dx<0 ? 1 : -1));}, {passive:true});
      });
      gallery.addEventListener('hny:variant-media', e => {const i = thumbs.findIndex(t => t.dataset.mediaId === e.detail); if(i >= 0) show(i);});
      show(index);
    });
    root.querySelectorAll('[data-hny-product]').forEach(product => {
      if(product.dataset.ready) return;
      product.dataset.ready = 'true';
      const select = product.querySelector('[data-hny-variant]');
      const add = product.querySelector('[data-hny-add]');
      const price = product.querySelector('[data-hny-price]');
      const compare = product.querySelector('[data-hny-compare]');
      const radios = document.createElement('fieldset'); radios.className = 'hny-live-variants';
      const legend = document.createElement('legend'); legend.textContent = select.previousElementSibling.textContent; radios.append(legend);
      [...select.options].forEach(option => {
        const label = document.createElement('label'); const input = document.createElement('input'); const text = document.createElement('span');
        input.type = 'radio'; input.name = 'hny-variant-choice'; input.value = option.value; input.checked = option.selected; input.disabled = option.disabled;
        text.textContent = option.textContent; label.append(input,text); radios.append(label);
        input.addEventListener('change', () => {select.value = input.value; select.dispatchEvent(new Event('change'));});
      });
      select.before(radios); select.hidden = true; select.previousElementSibling.previousElementSibling.hidden = true;
      const guide=product.querySelector('.hny-size-guide');
      if(guide){
        const content=guide.querySelector('.hny-size-content');
        if(content){
          const guideButton=document.createElement('button');guideButton.type='button';guideButton.className='hny-size-launcher';guideButton.textContent='Size guide';
          content.id='HnySizeContent-'+(product.dataset.sectionId||select.id);guideButton.setAttribute('aria-controls',content.id);
          guideButton.setAttribute('aria-expanded',String(guide.open));legend.append(guideButton);guide.dataset.enhanced='true';
          guideButton.addEventListener('click',()=>{guide.open=!guide.open;});
          guide.addEventListener('toggle',()=>guideButton.setAttribute('aria-expanded',String(guide.open)));
        }
      }
      function update() {
        const option = select.selectedOptions[0];
        price.textContent = option.dataset.price;
        const quantity = product.querySelector('input[name="quantity"]');
        quantity.min = option.dataset.min; quantity.step = option.dataset.step;
        if(option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = Math.max(Number(quantity.value), Number(quantity.min));
        compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true';
        add.disabled = option.dataset.available !== 'true'; add.textContent = add.disabled ? 'Sold out' : 'Add to bag' + (option.dataset.label ? ' · ' + option.dataset.label : '');
        if (option.dataset.media) product.querySelector('[data-hny-gallery]')?.dispatchEvent(new CustomEvent('hny:variant-media', {detail:option.dataset.media}));
        radios.querySelectorAll('input').forEach(r => {r.checked = r.value === select.value;});
      }
      select.addEventListener('change', () => {
        update(); const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
  document.addEventListener('shopify:section:load', e => initialise(e.target));
})();
